import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

// Function to format date
export const formatDate = (dateString: string | undefined): string => {
    const now = dayjs();
    const ticketDate = dayjs(dateString);

    if (ticketDate.isSame(now, "day")) {
        return `Today ${ticketDate.format("hh:mm A")}`;
    } else if (ticketDate.isSame(now.subtract(1, "day"), "day")) {
        return `Yesterday ${ticketDate.format("hh:mm A")}`;
    } else {
        return ticketDate.format("MMMM D, YYYY");
    }
};
